const isAxiosError = (error: any) =>
  typeof error === 'object' && error?.isAxiosError;

export default { isAxiosError };
